"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-bartolomeo-al-mare": {
    "1a1be6f5": [{
      "hkey": "10be2561",
      "slug": "san-bartolomeo",
      "name": "San Bartolomeo",
      "primary": true,
      "skipSearch": false
    }],
    "poiolo": [{
      "hkey": "10be2561",
      "slug": "san-bartolomeo",
      "name": "San Bartolomeo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-bartolomeo-al-mare"
    }],
    "17fee35e": [{
      "hkey": "6281ee07",
      "slug": "san-bartolomeo-al-mare",
      "name": "San Bartolomeo al Mare",
      "primary": true,
      "skipSearch": false
    }],
    "rovere": [{
      "hkey": "6281ee07",
      "slug": "san-bartolomeo-al-mare",
      "name": "San Bartolomeo al Mare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;